import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { concat, from, Observable } from 'rxjs'
import { MeState } from './me.reducer'
import { Deps } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { notification } from 'antd'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { meActions, MeActions } from './me.actions'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

type Actions = MeActions

interface Action$ extends ActionsObservable<Actions> {}
interface State$ extends StateObservable<MeState> {}

const loadProfile = (dsService: DSService) => (p: { token: string; [startFetch]: string }) =>
  concat(
    from(
      dsService.me(p.token).map(profileOpt =>
        pipe(
          profileOpt,
          O.fold(
            () => {
              notification.error({
                description: 'Erreur lors du chargement de vos informations',
                message: 'Erreur'
              })
              meActions.LoadProfileFailed({ [stopFetch]: p[startFetch] })
            },
            profile => meActions.LoadProfileSuccess({ profile: profile.result, [stopFetch]: p[startFetch] })
          )
        )
      )
    )
  )

const updateProfile = (dsService: DSService) => (p: {
  email: string
  firstName: string
  lastName: string
  token: string
  [startFetch]: string
}): Observable<MeActions> =>
  concat(
    from(
      dsService
        .updateMyProfile({
          email: p.email,
          firstName: p.firstName,
          lastName: p.lastName,
          token: p.token
        })
        .map(updatedOpt =>
          pipe(
            updatedOpt,
            O.fold(
              () => {
                notification.error({
                  description: "Vos informations n'ont pas pu être mises à jour",
                  message: 'Erreur'
                })

                return meActions.UpdateMyProfileFailure({
                  [stopFetch]: p[startFetch]
                })
              },
              profile => {
                notification.success({
                  description: 'Vos informations ont bien été mises à jour',
                  message: 'Mise à jour réussie'
                })

                return meActions.UpdateMyProfileSuccess({
                  profile: profile.result,
                  [stopFetch]: p[startFetch]
                })
              }
            )
          )
        )
    )
  )

const updatePassword = (dsService: DSService) => (p: {
  oldPassword: string
  newPassword: string
  token: string
  [startFetch]: string
}): Observable<MeActions> =>
  concat(
    from(
      dsService
        .updateMyPassword({
          oldPassword: p.oldPassword,
          newPassword: p.newPassword,
          token: p.token
        })
        .map(updated =>
          pipe(
            updated,
            O.fold(
              () => {
                notification.error({
                  description: "Votre mot de passe n'a pas pu être mis à jour",
                  message: 'Erreur'
                })

                return meActions.UpdateMyPasswordFailure({
                  [stopFetch]: p[startFetch]
                })
              },
              _ => {
                notification.success({
                  description: 'Votre mot de passe a bien été mis à jour',
                  message: 'Mise à jour réussie'
                })

                return meActions.UpdateMyPasswordSuccess({
                  [stopFetch]: p[startFetch]
                })
              }
            )
          )
        )
    )
  )

export const updateProfileEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(meActions.is.UpdateMyProfile),
    mergeMap(updateProfile(deps.dsService))
  )

export const updatePasswordEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(meActions.is.UpdateMyPassword),
    mergeMap(updatePassword(deps.dsService))
  )

export const loadProfileEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(meActions.is.LoadProfile),
    mergeMap(loadProfile(deps.dsService))
  )

export const meEpics = combineEpics(updateProfileEpic, loadProfileEpic, updatePasswordEpic)



// WEBPACK FOOTER //
// ./src/users-components/me/me.epics.ts